// @flow
import React, {useMemo} from 'react';
import {Typography, Divider} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Instagram} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';
import {PropTypes} from 'prop-types';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {Link} from 'react-router-dom';
import queryString from 'query-string';
import env from '../../../../environment';
import {useStoreInfo} from '../../../store/utils';

type Props = {|
  open: boolean,
  handleClose: () => void,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 500,
    // height: 240,
    padding: theme.spacing(4),
  },
  productContainer: {
    height: '70%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
  },
  instagramButton: {
    marginTop: theme.spacing(2),
    width: '266px',
    height: '48px',
    borderRadius: '8px',
    background:
      'linear-gradient(115.94deg, #FBD624 -27.09%, #FF8E5B -5.81%, #D01D7E 28.33%, #801CC4 61.66%, #6127C4 82.55%)',
    fontSize: '1rem',
  },
  myIconSizeMedium: {
    '& > *:first-child': {
      fontSize: '24px',
    },
  },
  divider: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  cancelText: {
    marginTop: theme.spacing(2),
    fontSize: '0.875rem',
    color: colors.grey700,
  },
}));

const getRedirectUri = () => {
  if (env.environment === 'production') {
    return 'https://tiendada.com/redirect/instagram-product-upload-login/';
  }

  if (env.environment === 'development') {
    return 'https://dev.tiendada.com/redirect/instagram-product-upload-login/';
  }

  return 'https://local.tiendada.com/redirect/instagram-product-upload-login/';
};

function getInstagramOAuthUrl(stateObject) {
  const baseUrl = 'https://www.instagram.com/oauth/authorize';
  const params = new URLSearchParams({
    enable_fb_login: '0',
    force_authentication: '1',
    client_id: env.instagramUploadProductsClientId,
    redirect_uri: getRedirectUri(),
    response_type: 'code',
    scope: [
      'instagram_business_basic',
      'instagram_business_manage_messages',
      'instagram_business_manage_comments',
      'instagram_business_content_publish',
    ].join(','),
    state: btoa(JSON.stringify(stateObject)),
  });
  return `${baseUrl}?${params.toString()}`;
}

export default function InstagramProductsModal(props: Props) {
  const {open, handleClose} = props;

  const storeInfo = useStoreInfo();

  const classes = useStyles();
  const queryObject = queryString.parse(window.location.search);

  const storeId = storeInfo?.id;
  const igOAuthUrl = useMemo(() => {
    const {protocol, host} = window.location;
    const returnUrl = `${protocol}//${host}/admin/products/instagram-upload?${
      queryObject.fromOnboarding ? 'fromOnboarding=1' : ''
    }`;

    return getInstagramOAuthUrl({
      returnUrl,
      apiEndpoint: '/api/ui/admin/store/instagram-integration',
      storeId,
    });
  }, [queryObject.fromOnboarding, storeId]);

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Conecta tu cuenta de instagram para poder empezar a crear productos
        </Typography>
        <CustomButton
          variant="contained"
          classes={{
            root: classes.instagramButton,
            iconSizeMedium: classes.myIconSizeMedium,
          }}
          startIcon={<Instagram />}
          href={igOAuthUrl}
          disabled={!storeId}
        >
          Conectar a instagram
        </CustomButton>
        <Divider className={classes.divider} />
        <Typography className={classes.cancelText}>
          No deseo crear productos desde Instagram.{' '}
          <Link to="/products" onClick={handleClose}>
            Clic Aquí
          </Link>
        </Typography>
      </div>
    </CustomModal>
  );
}

InstagramProductsModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};
